import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import styled from 'styled-components';
import { FONTS } from '@ertelecom/ui-react/assets/js/constants';
import {
    ArrowWrapper,
    Counter,
    Dots,
    DotWrapper,
    LeftArrow,
    RightArrow,
    Slide,
    Wrapper,
    SliderWrapper,
    Container,
    Section
} from './styled';
import Carousel from '@ertelecom/ui-react/components/carousel';
import LotCard from '~/src/components/Main/Info/market/LotCard';
import { formattingRoutersForCard, formattingTvBoxesForCard } from '~/src/helpers/formatter';
import { addRouterInCheckLeasing, addRouterInCheckPossess } from '~/src/components/Request/helpers/routerRequest';
import { addTvBoxInCheckLeasing, addTvBoxInCheckPosess } from '~/src/components/Request/helpers/tvBoxRequest';
import { setCheckListAction } from '~/src/store/actions/village-detail';

const DEFAULT_PIC = '/static/images/work-in-home/img.png';

const WrapperText = styled.div`
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
`;

const Title = styled.h2`
    margin-top: 0;
    margin-bottom: 10px;
    ${FONTS.H3};
    color: #1A1A1A;
`;

const Description = styled.p`
    margin: 0;
    ${FONTS.S};
    color: #1A1A1A;
`;

const EquipmentList = ({ routers = [], tvBoxes = [], domain, checkList, setCheckList, productData }) => {

    routers = Array.isArray(routers) ? routers : [];
    tvBoxes = Array.isArray(tvBoxes) ? tvBoxes : [];

    const isXpon = productData?.product?.description?.alias.indexOf('-xpon') !== -1;

    const equipments = useMemo(() => ([...formattingTvBoxesForCard(tvBoxes, isXpon), ...formattingRoutersForCard(routers)]), []);

    if (!equipments.length) {
 return null;
}

    const CustomCounter = props => {
        const { active, count, onClick, slidesToShow } = props;
        const dots = [];
        for (let i = 0; i <= count; i++) {
            dots.push(<Dots key={i} active={i === active} onClick={() => onClick(i)}/>);
        }
        return (
            <Wrapper>
                <DotWrapper>
                    {dots}
                </DotWrapper>

                <Counter>
                    {`Показано
                        ${1 + active === 2 ? 'co' : 'c'}
                        ${1 + active} по
                        ${(slidesToShow) + active} из ${equipments.length}`
                    }
                </Counter>
            </Wrapper>
        );
    };

    const CustomArrows = props => {
        const { swipeLeft, swipeRight } = props;
        return (
            <ArrowWrapper>
                <LeftArrow type='secondary' onClick={swipeLeft}/>
                <RightArrow type='secondary' onClick={swipeRight}/>
            </ArrowWrapper>
        );
    };

    const settings = {
        breakpoints: [
            { width: 0, slidesToShow: 1 },
            { width: 920, slidesToShow: 2 },
            { width: 1280, slidesToShow: 3 }
        ]
    };

    /**
     *
     * @description remove equipment from check
     * @param {number} materialsEnsId
     */
    const deleteEquipment = materialsEnsId => {

        const augmentedCheck = { ...checkList };

        const monthly = { ...augmentedCheck.monthly };
        const newListMonthly = monthly.list.filter(equipment => {
            if (equipment.materialsEnsId === materialsEnsId) {
                monthly.total -= equipment.price;
                return false;
            } else {
                return true;
            }
        });
        monthly.list = newListMonthly;

        const once = { ...augmentedCheck.once };
        const newOnce = once.list.filter(equipment => {
            if (equipment.materialsEnsId === materialsEnsId) {
                once.total -= equipment.price;
                return false;
            } else {
                return true;
            }
        });
        once.list = newOnce;

        augmentedCheck.monthly = monthly;
        augmentedCheck.once = once;

        setCheckList(augmentedCheck);
    };

    /**
     *
     * @param {number} itemId
     * @param {number || undefined} leasingDuration
     * @param {string} priceType (leasing or possess)
     */
    const onClickButtonOfCard = ({ itemId, leasingDuration, priceType }) => {
        let augmentedCheck = { ...checkList };
        const equipment = equipments.find(equipment => equipment.materialsEnsId === itemId);
        if (!equipment) {
 return;
}
        if (priceType === 'leasing') {
            const leasingOption = equipment.leasingOptions.find(currentLeasingOption => currentLeasingOption.duration === leasingDuration);
            if (equipment.typeEquipment === 'router') {
                augmentedCheck = addRouterInCheckLeasing(equipment, leasingOption, checkList, deleteEquipment);
            } else if (equipment.typeEquipment === 'tvBox') {
                augmentedCheck = addTvBoxInCheckLeasing(equipment, leasingOption, checkList, deleteEquipment);
            }
        } else if (equipment.typeEquipment === 'router') {
                augmentedCheck = addRouterInCheckPossess(equipment, checkList, deleteEquipment);
            } else if (equipment.typeEquipment === 'tvBox') {
                augmentedCheck = addTvBoxInCheckPosess(equipment, checkList, deleteEquipment);
            }

        setCheckList(augmentedCheck);
    };

    return (
        <Section>
            <Container>
                <WrapperText>
                    <Title>Выберите оборудование для интернета и ТВ</Title>
                    <Description>Правильный роутер гарантирует высокую скорость на всех устройствах в доме. А на ТВ-приставке всегда есть, что посмотреть.</Description>
                </WrapperText>
                <SliderWrapper data-test='carousel-container'>
                    {
                        <Carousel
                            visibleCardWidth={920}
                            responsive={settings.breakpoints}
                            showDots={true}
                            dots={CustomCounter}
                            arrows={CustomArrows}
                        >
                            {Boolean(equipments.length) && equipments.map(equipment => {
                                const materialsEnsId = equipment.materialsEnsId;
                                const existInCheckMonthly = checkList.monthly.list.findIndex(equipFromCheck => equipFromCheck.materialsEnsId === materialsEnsId);
                                const existInCheckOnce = checkList.once.list.findIndex(equipFromCheck => equipFromCheck.materialsEnsId === materialsEnsId);
                                const existInCheck = existInCheckMonthly >= 0 || existInCheckOnce >= 0;
                                return (
                                    <Slide key={materialsEnsId}>
                                        <LotCard
                                            orderId={materialsEnsId}
                                            domain={domain}
                                            description={equipment.description}
                                            name={equipment.title}
                                            price={`${equipment.price}`}
                                            exist={existInCheck}
                                            button_text_exists='Добавлено в чек'
                                            button_text='Добавить к тарифу'
                                            image={equipment.image ? equipment.image : DEFAULT_PIC}
                                            data={equipment.leasingOptions}
                                            freeText='бесплатно доставим и настроим '
                                            priceTextBoolean={true}
                                            promo={equipment.promo}
                                            onClickButton={onClickButtonOfCard}
                                        />
                                    </Slide>
                                );
                            })}
                        </Carousel>
                    }
                </SliderWrapper>
            </Container>
        </Section>
    );
};

const selectorForTvBox = createSelector(
    state => state.tvBoxes.tvBoxes,
    tvBoxes => tvBoxes.filter(item => item.materials_ens_id !== 57043)
);

const mapStateToProps = state => ({
    routers: state.routers,
    tvBoxes: selectorForTvBox(state),
    domain: state.city.currentCity.domain,
    checkList: state.villageDetail.checkList,
    productData: state.villageDetail.productData
});

const mapDispatchToProps = dispatch => ({
    setCheckList: checkList => dispatch(setCheckListAction(checkList))
});

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentList);
